import type { IconData } from '@stacksjs/iconify-core'

export const testTubeSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.687 2.095C13.598 1.817 18.19 1.5 24 1.5c5.808 0 10.402.317 13.313.595c1.963.187 2.823 2.446 1.59 3.936l-2.88 3.482v16.058c0 4.213-.07 7.74-.167 10.586c-.186 5.519-4.266 10.103-9.843 10.306a55 55 0 0 1-3.96.002c-5.61-.198-9.714-4.825-9.905-10.374L12.113 35H17a2 2 0 1 0 0-4h-4.98a327 327 0 0 1-.044-5H17a2 2 0 1 0 0-4h-5.024v-5H17a2 2 0 1 0 0-4h-5.024V9.513l-2.88-3.482c-1.232-1.49-.373-3.749 1.59-3.936\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default testTubeSolid
